export default "data:image/webp;base64,UklGRkgAAABXRUJQVlA4TDwAAAAvJ4AGAFATSQpj4VGe5WACU6mmIQswyZ8kmpEsgw41jaTAQRf31lCiif5PABhi22LraGcv8v0BL29O7AU="